import React, { FC } from 'react';
import { Box, Typography } from '@mui/material';
import colors from 'src/styles/equalution/colors';

import { GIFT_CAMPAIGN } from './constants';
import { GiftTimerState } from './useGiftTimer';

interface Props {
  timer: GiftTimerState;
  /** Optional: render as sticky banner. Defaults to true. */
  sticky?: boolean;
  bannerLabel?: string;
  bannerExpiredLabel?: string;
}

const GiftCountdownBanner: FC<Props> = ({
  timer,
  sticky = true,
  bannerLabel,
  bannerExpiredLabel,
}) => {
  if (!timer.active) return null;

  const { expired, warning, mmss } = timer;

  const bg = expired
    ? colors.OFF_BLACK
    : warning
    ? colors.ORANGE_HALF
    : colors.SALAD;
  const fg = expired ? colors.WHITE : colors.WHITE;

  return (
    <Box
      sx={{
        position: sticky ? 'sticky' : 'static',
        top: 0,
        zIndex: 10,
        width: '100%',
        bgcolor: bg,
        color: fg,
        textAlign: 'center',
        py: '8px',
        px: '12px',
      }}>
      <Typography
        sx={{
          fontSize: '14px',
          fontWeight: 600,
          color: fg,
          letterSpacing: '0.5px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexWrap: 'wrap',
          gap: '6px',
        }}>
        {expired ? (
          <span>
            {bannerExpiredLabel || GIFT_CAMPAIGN.copy.bannerExpiredLabel}
          </span>
        ) : (
          <>
            <span>{bannerLabel || GIFT_CAMPAIGN.copy.bannerLabel}</span>
            <Box
              component="span"
              sx={{
                fontSize: '18px',
                fontWeight: 800,
                ml: '2px',
              }}>
              {mmss}
            </Box>
          </>
        )}
      </Typography>
    </Box>
  );
};

export default GiftCountdownBanner;
